import $api from "@/core/services/ApiService";
import type { Credentials } from "@/core/services/api/interfaces/auth/Credentials";
import { AxiosRequestConfig } from "axios";
import { ForgotPassword } from "@/core/services/api/interfaces/auth/ForgotPassword";
import ChangePassword from "@/core/services/api/interfaces/auth/ChangePassword";
import { Registration } from "@/core/services/api/interfaces/auth/Registration";
import { IFrameCredentials } from "@/core/services/api/interfaces/auth/Credentials";

class AuthEndpoint {
  public rocketChat() {
    return $api.post("auth/rocket-chat");
  }
  public login(credentials: Credentials) {
    return $api.post("auth/login", credentials);
  }
  public loginIframe(credentials: IFrameCredentials) {
    return $api.post("auth/login-iframe", credentials as AxiosRequestConfig);
  }
  public registration(data: Registration) {
    const affiliation = data.affiliation || "";
    delete data.affiliation;
    let url = "auth/registration";
    if (affiliation) {
      url = `auth/registration/${affiliation}`;
    }

    return $api.post(url, data);
  }
  public forgotPassword(data: ForgotPassword) {
    return $api.post("auth/forgot-password", data);
  }
  public resetPassword(
    user_id: string | number,
    code: string,
    data: ChangePassword
  ) {
    return $api.post(`/auth/reset-password/${user_id}/${code}`, data);
  }
  public hasResetPassword(user_id: string | number, code: string) {
    return $api.get(`/auth/reset-password/${user_id}/${code}`);
  }
  public loginFromLegacy(key: string) {
    return $api.post("auth/from-legacy", { key } as AxiosRequestConfig);
  }
  public loginFromFlexPsp(user_id: number, auth_key: string) {
    return $api.post("auth/flexpsp", {
      user_id,
      auth_key,
    } as AxiosRequestConfig);
  }
  public loginFromRemotePortal(portal: string, key: string) {
    return $api.post(`auth/portals/${portal}/${key}`);
  }
  public approveEmail(key: string, code: string) {
    return $api.post(`auth/approve-email/${key}/${code}`);
  }
  public affiliateOwnerByGuest(key: string) {
    return $api.get(`auth/affiliate-owner/${key}`);
  }
  public loginToLegacy() {
    return $api.post("auth/to-legacy");
  }
  public logout() {
    return $api.post("auth/logout");
  }
  public refresh() {
    return $api.post("auth/refresh");
  }
  public me() {
    return $api.get("auth/me");
  }
}

export default AuthEndpoint;
